ALLOWED_CONTROLLER = 'work_orders'
ALLOWED_ACTIONS = ['index']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)

  workOrdersTable = $('#work_orders').dataTable
    sPaginationType: "full_numbers"
    bJQueryUI: true
    bProcessing: true
    bServerSide: true
    iDisplayLength: 50
    sAjaxSource: $('#work_orders').data('source')
    order: [ [ 0, "desc" ] ]
    aoColumnDefs:
      [ { 'bSortable': false, 'aTargets': [ 7 ] } ]

$(document).ready(ready)
